window.stripeCalculation = function (billing_surcharge,stripe_fee,stripe_cent,gst_fee,is_gst,amount) {

    let processing_stripe_fee = roundTo(parseInt(amount,10) * (stripe_fee) + (stripe_cent),2);
    let processing_giftit_fee = parseFloat(billing_surcharge);
    let processing_fee = roundTo(parseFloat(processing_stripe_fee) + parseFloat(processing_giftit_fee),2);
    let gst = (is_gst === 1)? roundTo(parseFloat(processing_fee) * gst_fee,2) : 0;

    let total = roundTo(parseInt(amount,10) + parseFloat(processing_fee) + parseFloat(gst),2);
    // console.log({
    //     processing_stripe_fee:processing_stripe_fee,
    //     processing_giftit_fee:processing_giftit_fee,
    //     processing_fee:processing_fee,
    //     gst:gst,
    // });

    return total;
}

window.stripeEventCalculation = function (billing_surcharge,stripe_fee,stripe_cent,gst_fee,is_gst,amount) {

    let processing_stripe_fee = roundTo(parseInt(amount,10) * (stripe_fee) + (stripe_cent),2);
    let processing_giftit_fee = parseFloat(billing_surcharge);
    let processing_fee = roundTo(parseFloat(processing_stripe_fee) + parseFloat(processing_giftit_fee),2);
    let gst = (is_gst === 1)? roundTo(parseFloat(processing_fee) * gst_fee,2) : 0;

    let total = roundTo(parseInt(amount,10) + parseFloat(processing_fee) + parseFloat(gst),2);
    // console.log({
    //     processing_stripe_fee:processing_stripe_fee,
    //     processing_giftit_fee:processing_giftit_fee,
    //     processing_fee:processing_fee,
    //     gst:gst,
    // });

    return total;
}

function roundTo(n, digits) {
    if (digits === undefined) {
        digits = 0;
    }

    var multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    var test =(Math.round(n) / multiplicator);
    return +(test.toFixed(digits));
}


// WEBPACK FOOTER //
// ./resources/assets/website/scripts/stripeCalculation.js